import React from "react";

import { cn } from "@/utils/cn";

interface BannerProps {
  theme: "default" | "opaque";
  children: React.ReactNode;
  className?: string;
}

/** Displays a sticky full-width banner at the bottom of the screen. */
const Banner: React.FC<BannerProps> = ({ theme, children, className }) => {
  return (
    <div
      data-testid="banner"
      className={cn(
        "fixed inset-x-0 bottom-0 z-50 bg-background py-8 text-foreground",
        {
          "border-t": theme === "default",
          "shadow-3xl dark:shadow-inset": theme === "opaque",
        },
        className,
      )}
    >
      <div className="mx-auto max-w-4xl px-4">{children}</div>
    </div>
  );
};

export default Banner;
